import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { VALIDATION } from "../../AppConstants";
import { IDriverBase } from "../../classes/Domain";

const rules = {
    firstName: 'required',
    lastName: 'required',
    licenseNumber: 'required',
    licenseState: ['required', 'regex:/^[aA-zZ]{2,3}$/']
};

const customErrorMessages = {
    "regex.birthDate": VALIDATION.DATE_FORMAT,
};

export const allFieldsValidation = (data: IDriverBase) => {
    rules["birthDate"] = data.isInsured
        ? ['required', 'regex:/^\\d{2}\\/\\d{2}\\/\\d{4}$/', 'valid_date', 'valid_insured_age', 'valid_age']
        : ['required', 'regex:/^\\d{2}\\/\\d{2}\\/\\d{4}$/', 'valid_date', 'valid_driver_age', 'valid_age']
    return allFieldsValidationCommon(data, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};